"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasonryGridItem = exports.MasonryGrid = void 0;
const vue_1 = require("vue");
const imagesloaded_1 = __importDefault(require("imagesloaded"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const resizeGridItem = (item) => {
    let grid = item;
    while (grid !== null && typeof grid.classList !== 'undefined' && !grid.classList.contains('masonry-grid')) {
        grid = grid.parentElement;
    }
    if (!grid || grid === window.document.documentElement) {
        // masonry-grid root element not yet inserted
        return;
    }
    const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
    if (item instanceof HTMLElement) {
        item.style.gridRowEnd = `span 1`; // reset
    }
    const rowSpan = Math.ceil((item.scrollHeight
        + parseFloat(window.getComputedStyle(item).getPropertyValue('margin-bottom'))
        + parseFloat(window.getComputedStyle(item).getPropertyValue('padding-bottom'))
        + rowGap)
        /
            (rowHeight + rowGap));
    if (item instanceof HTMLElement) {
        item.style.gridRowEnd = `span ${rowSpan}`;
    }
};
const resizeAllGridItems = (rootelement = null) => {
    let allItems;
    if (rootelement === null) {
        allItems = window.document.querySelectorAll('.masonry-grid .masonry-grid-item');
    }
    else {
        allItems = rootelement.querySelectorAll('.masonry-grid-item');
    }
    for (let x = 0; x < allItems.length; x++) {
        resizeGridItem(allItems[x]);
    }
};
exports.MasonryGrid = (0, vue_1.defineComponent)({
    name: 'MasonryGrid',
    props: {
        minMax: {
            type: String,
            default: '22rem'
        },
        columnGap: {
            type: String,
            default: 'gap-x-7'
        }
    },
    setup(props) {
        const grid = (0, vue_1.ref)(null);
        const minMax = () => {
            var _a, _b;
            if (grid.value) {
                const gridWidth = grid.value.getBoundingClientRect().width;
                const firstItemWidth = (_b = (_a = grid.value.querySelector('.masonry-grid-item')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0;
                if (gridWidth < firstItemWidth) {
                    return `10rem`;
                }
            }
            return props.minMax;
        };
        window.addEventListener('DOMContentLoaded', (0, debounce_1.default)(() => resizeAllGridItems(grid.value), 150));
        window.addEventListener('resize', (0, debounce_1.default)(() => {
            if (grid.value) {
                grid.value.style.gridTemplateColumns = `repeat(auto-fill, minmax(${minMax()}, 1fr))`;
            }
            resizeAllGridItems(grid.value);
        }, 150));
        (0, vue_1.onMounted)(() => {
            (0, vue_1.nextTick)(() => {
                if (grid.value) {
                    grid.value.classList.add(props.columnGap);
                    grid.value.style.gridTemplateColumns = `repeat(auto-fill, minmax(${minMax()}, 1fr))`;
                    resizeAllGridItems(grid.value);
                }
            });
        });
        (0, vue_1.onUpdated)(() => {
            (0, vue_1.nextTick)(() => {
                resizeAllGridItems(grid.value);
            });
        });
        return {
            grid,
        };
    },
    template: /* html */ `
        <div
            class="masonry-grid grid grid-flow-row gap-y-px"
            style="grid-auto-rows: 10px;"
            ref="grid">
            <slot></slot>
        </div>
    `,
});
exports.MasonryGridItem = (0, vue_1.defineComponent)({
    name: 'MasonryGridItem',
    props: {
        bottomGap: {
            type: String,
            default: 'mb-7'
        }
    },
    setup(props) {
        const gridItem = (0, vue_1.ref)(null);
        (0, vue_1.onMounted)(() => {
            if (gridItem.value === null) {
                return;
            }
            gridItem.value.classList.add(props.bottomGap);
            if (gridItem.value.querySelector('img') !== null) {
                (0, imagesloaded_1.default)(gridItem.value, () => {
                    if (gridItem.value) {
                        resizeGridItem(gridItem.value);
                    }
                });
            }
        });
        (0, vue_1.onUpdated)(() => {
            if (gridItem.value) {
                resizeGridItem(gridItem.value);
            }
        });
        return {
            gridItem,
        };
    },
    template: /* html */ `
        <div class="masonry-grid-item" ref="gridItem"><slot></slot></div>
    `,
});
